import { xTravelWorldUrl } from '../../../settings'

export const updateXTravelMarginUrl = () => {
  return xTravelWorldUrl + '/x-travel/updateAgentXTravelMargin'
}

export const singleAgentXTravelMarginUrl = () => {
  return xTravelWorldUrl + '/x-travel/getAgentXTravelMargin'
}

export const singleXTravelExchangeMarginUrl = () => {
  return xTravelWorldUrl + '/x-travel/getExchangeMargin'
}

export const updateXTravelExchangeMarginUrl = () => {
  return xTravelWorldUrl + '/x-travel/updateExchangeMargin'
}

export const addXTravelFundTransferRequestUrl = () => {
  return xTravelWorldUrl + '/xTravel/addXTravelFundTransferRequest'
}

export const getAllFundTransferRequestUrl = () => {
  return xTravelWorldUrl + '/xTravel/getAllFundTransferRequest'
}

export const updateFundTransferRequestUrl = () => {
  return xTravelWorldUrl + '/xTravel/updateFundTransferRequest'
}

export const getAgentMarginActivityUrl = () => {
  return xTravelWorldUrl + '/x-travel/getAllAgentMarginActivity'
}

export const addDirectDepositUrl = () => {
  return xTravelWorldUrl + '/x-travel/addDirectDeposit'
}

export const getAllDirectDepositUrl = () => {
  return xTravelWorldUrl + '/x-travel/getAllDirectDeposit'
}
export const approveDirectDepositUrl = () => {
  return xTravelWorldUrl + '/x-travel/approveDirectDeposit'
}
export const getProfitAndLossUrl = () => {
  return xTravelWorldUrl + '/x-travel/getProfitLoss'
}

export const addEventXTravelUrl = () => {
  return xTravelWorldUrl + '/x-travel/addEventXTravel'
}
export const getAllEventsUrl = () => {
  return xTravelWorldUrl + '/x-travel/eventList'
}
export const getEventDataByIdUrl = () => {
  return xTravelWorldUrl + '/x-travel/getEventById'
}
export const addMeetingXTravelUrl = () => {
  return xTravelWorldUrl + '/x-travel/addMeeting'
}
export const getAllMeetingsUrl = () => {
  return xTravelWorldUrl + '/x-travel/meetingList'
}
